<template lang="html">
<div class="popup" :class="{'visible': visible }">
  <div class="container">
    <div class="wrapper">
      <div class="header">
        <div class="close" @click="close()"></div>

        <div class="header-title text-center">
          {{ $t("footer.cancelSubscription.title") }}
        </div>
      </div>

      <div class="form-wrapper" v-if="!success">
        <!--
        <div class="apple-button-wrapper" v-if="$parent.$refs.sub.apple_pay_available">
          <button class="apple-button" :class="{'loading': loading}" @click="cancelWithApplePay()">Cancel with&nbsp;<span class="apple">Pay</span></button>
          <div class="or">or</div>
        </div>
        -->

        <form id="cancel-subscription-form">
          <input v-model="email" type="email" required :placeholder="$t('footer.cancelSubscription.emailPlaceholder')" @input="validate">
          <input v-model="last4" type="text" maxlength=4 required :placeholder="$t('footer.cancelSubscription.cardPlaceholder')" @input="validate">

          <button type="submit" @click="cancel" :disabled="!formValid || loading" :class="{'loading': loading }">
            {{$t("footer.cancelSubscription.cancel")}}
          </button>

          <p v-if="error" class="error">{{$t("footer.cancelSubscription.errorToCancel")}}</p>
        </form>

        <div>
          <div class="note">
            {{$t("footer.cancelSubscription.caption[0]")}}
          </div>
          <p class="note">{{$t("footer.cancelSubscription.caption[1]")}} {{ support_email }}</p>
        </div>
      </div>

      <div class="form-wrapper" v-if="success">
        <form>
          <h3>{{$t("footer.cancelSubscription.subscriptionCanceled")}}</h3>

          <button class="button" @click="close">{{$t("footer.cancelSubscription.close")}}</button>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      success: false,
      error: false,

      last4: null,
      email: null,
      formValid: false,

      support_email: 'support@' + document.location.host,
    }
  },
  methods: {
    validate() {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.formValid = this.last4 && this.last4.length == 4 && re.test(this.email)
    },
    open(event) {
      event && event.preventDefault()
      document.body.style.overflowY = 'hidden'
      this.visible = true
    },
    close(event) {
      event && event.preventDefault()
      document.body.style.overflowY = ''
      this.visible = false
    },
    cancel(event) {
      event && event.preventDefault()

      const url = '/api/subscription/cancel-by-email-and-card/'
      const form = new FormData()

      form.append('email', this.email)
      form.append('last4', this.last4)

      this.loading = true
      this.error = false

      fetch(url, {method: 'POST', body: form})
        .then(r => {
          this.loading = false
          if (r.status == 200) {
            this.success = true
          } else {
            this.error = true
          }
        })
    }
  },

  mounted() {
    let links = document.querySelectorAll('.cancel-subscription')

    links.forEach((navLink) => {
      navLink.style.display = ''
      navLink.addEventListener('click', (event) => {
        event && event.preventDefault()
        this.open()
      })
    })

    if (document.location.hash == '#cancel-subscription') {
      this.open()
    }
  }
}
</script>

<style lang="sass" scoped>
form input[type=email]
  margin-bottom: 5px
</style>
